// Relleno que usa `normalizeApiError` cuando la respuesta no trae ningún
// mensaje. Se exporta como constante para que `toUserMessage` pueda
// distinguir "el backend explicó el error" de "no dijo nada" — si los dos
// textos se escribieran sueltos, cualquier retoque en uno rompería esa
// distinción en silencio.
const MENSAJE_SIN_DETALLE = 'Ocurrio un error inesperado.'

export function normalizeApiError(error, context = {}) {
  const response = error?.response || null
  const data = response?.data || {}
  const status = response?.status || 0
  const method = (error?.config?.method || context.method || 'GET').toUpperCase()
  const endpoint = error?.config?.url || context.endpoint || ''

  const normalized = {
    ok: false,
    status,
    code: data.code || inferCodeByStatus(status),
    message: data.message || data.error || MENSAJE_SIN_DETALLE,
    details: data.details || null,
    trace_id: data.trace_id || null,
    endpoint,
    method,
  }

  return normalized
}

export function toUserMessage(normalizedError) {
  const code = normalizedError?.code
  const status = normalizedError?.status
  const detalleDelBackend = normalizedError?.message && normalizedError.message !== MENSAJE_SIN_DETALLE
    ? normalizedError.message
    : null

  if (code === 'STOCK_INSUFICIENTE') return 'Stock insuficiente para completar la operacion.'
  if (code === 'PERMISSION_DENIED' || status === 403) return 'No posee permisos para realizar esta accion.'
  if (code === 'CAJA_CERRADA') return 'No es posible registrar cobros. La caja se encuentra cerrada.'
  if (code === 'SYNC_PENDING') return 'La operacion fue registrada pero aun se esta sincronizando. Espere unos segundos.'

  // El 409 no es un error unico: el POS lo usa para conflictos de negocio muy
  // distintos entre si — email o documento ya registrado, pedido ya cobrado,
  // movimiento ya atendido, conflicto fiscal. Todos traen un mensaje propio,
  // redactado para el operador. Pisarlos con un texto generico deja al usuario
  // sin saber que corregir: el 2026-08-19 un alta de usuario fallo primero por
  // email duplicado y despues por documento duplicado, y las dos veces la
  // pantalla dijo lo mismo, aparentando que la validacion estaba trabada.
  // El texto generico queda solo para cuando el backend no explica nada.
  if (code === 'INVALID_STATE' || status === 409) {
    return detalleDelBackend || 'La operacion no es valida para el estado actual.'
  }

  if (status === 401) return 'Su sesion expiro. Inicie sesion nuevamente.'

  return detalleDelBackend || 'Ocurrio un error al procesar la solicitud.'
}

function inferCodeByStatus(status) {
  switch (status) {
    case 400: return 'BAD_REQUEST'
    case 401: return 'UNAUTHORIZED'
    case 403: return 'PERMISSION_DENIED'
    case 404: return 'NOT_FOUND'
    case 409: return 'INVALID_STATE'
    case 422: return 'UNPROCESSABLE_ENTITY'
    case 500: return 'INTERNAL_ERROR'
    default: return 'UNKNOWN_ERROR'
  }
}
